<template>
    <el-dialog
        title="新增"
        :visible.sync="addshow"
        :close-on-click-modal="false"
        @close="closeDialog"
        width="1000px"
        class="leader-dialog"
    >
        <div style="display: flex; height: 100%">
            <div style="height: 470px; width: 280px">
                <el-scrollbar style="height: 470px">
                    <div class="tree-wrap">
                        <me-tree
                            ref="myTree"
                            :defaultProps="defaultProps"
                            :treeData="treeList"
                            :nodeKey="'tree_id'"
                            :isSingle="false"
                            :showCheckbox="true"
                            :isCheckClick="true"
                            :checkStrictly="true"
                            :treeLoading="treeLoading"
                            :defaultExpandedKeys="defaultExpandedKeys"
                            :treeToolBar="false"
                            :default-expand-all="true"
                            @handleCheckBoxClick="handleTreeNodeClick"
                        ></me-tree>
                    </div>
                </el-scrollbar>
            </div>
            <el-form
                :rules="formRules"
                :model="addForm"
                ref="addForm"
                :show-message="false"
                class="leader-style-form"
            >
                <el-form-item label="设备名称" :label-width="formLabelWidth" prop="service_area_idAdd">
                    <el-input placeholder="请选择设备" v-model="tree_Names" :disabled="true"></el-input>
                </el-form-item>
                <div class="childForm_mr10 space_between h70">
                    <el-form-item
                        label="计划开始时间"
                        :label-width="formLabelWidth"
                        prop="plan_time_start"
                    >
                        <el-date-picker
                            v-model="addForm.plan_time_start"
                            type="datetime"
                            :disabled="isBackFill"
                            placeholder="选择日期"
                            :default-value="timeNow"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="gettime"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="计划结束时间" :label-width="formLabelWidth" prop="plan_time_end">
                        <el-date-picker
                            v-model="addForm.plan_time_end"
                            type="datetime"
                            :disabled="isBackFill"
                            placeholder="选择日期"
                            :default-value="timeNow"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="gettime"
                        ></el-date-picker>
                    </el-form-item>
                </div>
                <div class="childForm_mr10 space_between h70">
                    <el-form-item label="抢修负责人" :label-width="formLabelWidth" prop="leader_user_id">
                        <el-select v-model="addForm.leader_user_name" @change="chooseLeaderClick">
                            <el-option
                                v-for="(item, index) in leaderList"
                                :key="item.leader_user_id"
                                :label="item.leader_name"
                                :value="index"
                            ></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="抢修人员" :label-width="formLabelWidth" prop="users_id">
                        <el-select
                            v-model="userid"
                            @change="getDeviceListByData"
                            style="width: 100%;"
                            multiple
                        >
                            <el-option
                                v-for="item in userList"
                                :key="item.user_id"
                                :label="item.user_name"
                                :value="item.user_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </div>

                <el-form-item label="抢修内容" :label-width="formLabelWidth" prop="content">
                    <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入抢修内容"
                        v-model="addForm.content"
                    ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="addshow = false" class="leader-common-button">取消</el-button>
            <el-button
                type="primary"
                @click="addcommit('addForm')"
                :loading="this.$store.state.btnType"
                class="leader-common-button"
            >派单</el-button>
        </div>
    </el-dialog>
</template>
<script>
import * as api from '../api/index';
import Bus from '@/utils/eventBus.js';
import Tree from '@/comon/components/tree.vue';

export default {
    components: {
        'me-tree': Tree,
    },
    props: {
        addshow: {
            type: Boolean,
        },
        isnew: {
            type: Boolean,
        },
        tree_Names: {
            type: String,
        },
        tree_ids: {
            type: String,
        },
        chooseRow: {
            type: Object,
        },
        report_repair_id: {
            type: String,
        },
    },
    watch: {
        addshow(newVal) {
            if (newVal) {
                if (this.isnew) {
                    // this.addForm.plan_time_start='';
                    // this.addForm.plan_time_end='';
                    // this.addForm.leader_user_id='';
                    // this.addForm.users_id='';
                    // this.addForm.content='';
                    this.$nextTick(() => {
                        this.$refs['addForm'].resetFields();
                        if (this.report_repair_id) {
                            //抢修
                            this.$nextTick(() => {
                                this.$refs.myTree.$refs.tree.setCheckedKeys([
                                    ...this.tree_ids.split(','),
                                ]);
                            });
                        } else {
                            //新增
                            this.$refs.myTree.$refs.tree.setCheckedKeys([]);
                        }
                    });
                } else {
                    this.addForm.rush_repair_id = this.chooseRow.rush_repair_id;
                    this.addForm.plan_time_start = this.chooseRow.plan_time_start;
                    this.addForm.plan_time_end = this.chooseRow.plan_time_end;
                    this.addForm.leader_user_id = this.chooseRow.leader_id;
                    this.addForm.leader_user_name = this.chooseRow.leader_name;
                    this.addForm.users_id = this.chooseRow.worker_ids;
                    this.addForm.content = this.chooseRow.content;
                    this.tree_Names = this.chooseRow.tree_names;
                    this.tree_ids = this.chooseRow.tree_ids;
                    this.$nextTick(() => {
                        this.$refs.myTree.$refs.tree.setCheckedKeys([
                            ...this.chooseRow.tree_ids.split(','),
                        ]);
                    });

                    this.userList = [];
                    //给抢修人员赋值，备选列表值
                    this.leaderList.forEach((item) => {
                        if (
                            this.addForm.leader_user_id == item.leader_user_id
                        ) {
                            this.userList = item.userList;
                        }
                    });
                    var namelist = this.chooseRow.worker_ids.split(',');
                    this.userid = namelist;
                }
                this.getPointTree();
            }
        },
    },
    data() {
        return {
            formLabelWidth: '120px',
            //新增弹窗数据块
            addForm: {
                plan_time_start: '',
                plan_time_end: '',
                leader_user_id: '',
                leader_user_name: '',
                users_id: '',
                content: '',
            },
            addshow: false,
            treeList: [],
            treeLoading: false,
            // tree_id: "1",
            defaultProps: {
                children: 'childList',
                label: 'tree_name',
            },
            tree_ids: '',
            tree_Names: '',
            formRules: {
                leader_user_id: [
                    {
                        required: true,
                        message: '请选择抢修负责人',
                        trigger: 'change',
                    },
                ],
                users_id: [
                    {
                        required: true,
                        message: '请选择抢修人员',
                        trigger: 'blur',
                    },
                ],
                plan_time_start: [
                    {
                        required: true,
                        message: '请选择开始时间',
                        trigger: 'change',
                    },
                ],
                plan_time_end: [
                    {
                        required: true,
                        message: '请选择结束时间',
                        trigger: 'change',
                    },
                ],
                content: [
                    {
                        required: true,
                        message: '请填写抢修内容',
                        trigger: 'blur',
                    },
                ],
            },
            leaderList: [],
            userList: [],
            userid: [],
        };
    },
    created() {
        this.getLeader();
    },
    methods: {
        closeDialog() {
            //清空输入数据
            this.addForm.plan_time_start = '';
            this.addForm.plan_time_end = '';
            this.addForm.leader_user_id = '';
            this.addForm.leader_user_name = '';
            this.addForm.worker_ids = '';
            this.addForm.content = '';

            this.addshow = false;
            this.$emit('update:addshow', this.addshow);
            this.$refs['addForm'].resetFields();
            this.$refs['addForm'].clearValidate();
        },
        getPointTree() {
            this.treeLoading = true;
            api.getUnitDocTreeList().then((res) => {
                if (res) {
                    this.treeList = res.bus_json;
                }
                this.treeLoading = false;
            });
        },
        handleTreeNodeClick(select) {
            (this.tree_ids = ''),
                this.$refs.myTree.$refs.tree
                    .getCheckedKeys()
                    .forEach((item) => {
                        this.tree_ids += item + ',';
                    });
            if (this.tree_Names.match(select.tree_name)) {
                //判断若已经包含当前选择id，则表示当前操作为取消选择，故把当前节点去掉
                this.tree_Names = this.tree_Names.replace(
                    select.tree_name + ',',
                    ''
                );
            } else {
                this.tree_Names += select.tree_name + ',';
            }
        },
        getLeader() {
            api.getLeader({}).then((res) => {
                this.leaderList = res.bus_json;
                this.loading = false;
            });
        },
        saveRushRepair() {
            if (this.isnew) {
                // if (this.tree_ids.split(',').length > 1) {
                //     this.tree_ids = this.tree_ids.substring(0, this.tree_ids.length - 1);
                // }
                if (this.addForm.users_id.length > 1) {
                    this.addForm.users_id = this.addForm.users_id.substring(
                        0,
                        this.addForm.users_id.length - 1
                    );
                }
            }
            const param = {
                rush_repair_id: this.addForm.rush_repair_id,
                tree_ids: this.tree_ids,
                plan_time_start: this.addForm.plan_time_start,
                plan_time_end: this.addForm.plan_time_end,
                leader_id: this.addForm.leader_user_id,
                worker_ids: this.addForm.users_id,
                content: this.addForm.content,
                report_repair_id: this.report_repair_id
                    ? this.report_repair_id
                    : null,
            };
            if (this.report_repair_id)
                param.report_repair_id = this.report_repair_id;
            api.saveRushRepair(param).then((res) => {
                if (res.error_code === '0') {
                    this.$message({
                        message: '派单成功！',
                        type: 'success',
                    });
                    //清空输入数据
                    this.addForm.plan_time_start = '';
                    this.addForm.plan_time_end = '';
                    this.addForm.leader_user_id = '';
                    this.addForm.leader_user_name = '';
                    this.addForm.worker_ids = '';
                    this.addForm.content = '';

                    //通知前页对话框关闭
                    this.addshow = false;
                    this.$emit('update:addshow', this.addshow);
                    Bus.$emit('refresh', this.addshow);
                } else {
                    this.$message({
                        message: res.bus_json,
                        type: 'error',
                    });
                }
            });
        },
        getDeviceListByData(item) {
            this.addForm.users_id = '';
            item.forEach((single) => {
                this.addForm.users_id += single + ',';
            });
        },
        chooseLeaderClick(item) {
            this.addForm.leader_user_id = this.leaderList[item].leader_user_id;
            this.addForm.leader_user_name = this.leaderList[item].leader_name;
            this.userList = this.leaderList[item].userList;
            this.userid = []; //清除选择的抢修人员，需重新选择
        },
        addcommit() {
            if (this.tree_Names.length == 0) {
                this.$message('请先选择设备！');
                return;
            }
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.$confirm('确认派单该数据?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    })
                        .then(() => {
                            this.saveRushRepair();
                        })
                        .catch((e) => {
                            this.$message({
                                type: 'info',
                                message: '未派单',
                            });
                        });
                }
            });
        },
    },
};
</script>
<style lang="scss">
.repair_add {
    .dataclass {
        .el-date-editor .el-range-input {
            background-color: transparent;
            color: #ffffff;
        }
    }
}
.el-time-panel__footer {
    .confirm {
        width: 2.72rem !important;
        height: 1.12rem;
        background: transparent;
        border-radius: 1.12rem;
        border: none;
        outline: none;
        color: #409eff !important;
    }
}
</style>
